import GaslinkMeterSearch from "../components/gaslink/GaslinkMeterSearch";

const Gaslink: React.FC = () => {
  return <GaslinkMeterSearch />;
};

export default Gaslink;
